import { jsx as r } from "react/jsx-runtime";
import { Z as c, H as i } from "../index-Dlw4JYvo.js";
import { c as n } from "../index-BNmRGtA6.js";
import { c as u } from "../clsx-OuTLNxxd.js";
import { B as m } from "../Badge-CSZVp16h.js";
import '../Status.css';const l = "_status_zv215_1", O = "_success_zv215_5", t = {
  status: l,
  success: O
}, f = n(t.status, {
  variants: {
    status: {
      WON: t.success,
      LOST: t.error
    }
  },
  defaultVariants: {
    status: "WON"
  }
}), W = ({
  className: a,
  status: s,
  ...o
}) => {
  if (s !== "WON" && s !== "LOST") return null;
  const e = {
    WON: "primary",
    LOST: "error"
  };
  return /* @__PURE__ */ r(
    m,
    {
      "aria-label": `${s.toLowerCase()}-badge`,
      className: u(f({ status: s }), a),
      isRound: !0,
      size: "l",
      variant: e[s],
      ...o,
      children: s === "WON" ? /* @__PURE__ */ r(c, {}) : /* @__PURE__ */ r(i, {})
    }
  );
};
export {
  W as Status
};
